import script from "./ProjectDangerZone.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDangerZone.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDangerZone.vue?vue&type=style&index=0&id=4fe54f6d&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe54f6d"]])

export default __exports__